// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"ConfirmationModal_modalContainer__3q68N","modalContent":"ConfirmationModal_modalContent__3SJNt"};